import axios from "axios";
import * as d3 from "d3";
import {
    colonAnnotation,
    fw_progressive_1way,
    inrFormatter,
    make_x_gridlines,
    make_y_gridlines,
    numberFormat,
    responsivefy
} from '../functions'

export default function (chart, divId, vizName, filterParam, gridflag) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar

    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId)
        .append('svg')
        .attr('width', chart.width + chart.margin.left + chart.margin.right)
        .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
        .call(responsivefy)
        .append('g')
        .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

    axios.post(url, filterParam).then(response => {
        let data = response.data

        // nest function allows to group the calculation per level of a factor
        var sumstat = d3.nest().key(d => {
            return d.dim1_name
        }).sortKeys(d3.ascending).entries(data)
        // Add X-axis for date and Y-axis
        var x1Scale = d3.scaleLinear().range([0, chart.width]).domain([d3.min(data, d => {
            return d.metric1
        }), d3.max(data, d => {
            return d.metric1
        })])
        var y1Scale = d3.scaleLinear().domain([0, d3.max(data, d => {
            return d.metric2
        })]).range([chart.height, 0])


        svg.append('g')
            .attr('transform', 'translate(0,' + chart.height + ')')
            .call(d3.axisBottom(x1Scale))
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .style('text-anchor', 'end')
            .attr('dx', '-.8em')
            .attr('dy', '-.20em')
            .attr('transform', 'rotate(-60)')

        svg.append('text')
            .attr('x', (chart.width / 2))
            .attr('y', chart.height + chart.margin.bottom - chart.axisLabelDistance)
            .style('fill', fontColor)
            .text(chart.x1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left)
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('g')
            .call(d3.axisLeft(y1Scale).tickFormat(inrFormatter))
            .selectAll('text')
            .style('font-size', axisLabelFontSize)

        // color palette
        var res = sumstat.map(d => {
            return d.key
        }) // list of group main category
        var metric1ColorScale = d3.scaleOrdinal().domain(res).range(fw_progressive_1way)

        // Draw the line
        svg.selectAll('.line')
            .data(sumstat)
            .enter()
            .append('path')
            .attr('fill', 'none')
            .attr('stroke', d => {
                return metric1ColorScale(d.key)
            })
            .attr('stroke-width', 3)
            .attr('d', (d) => {
                let line = d3.line()
                    .x(d => {
                        return x1Scale(+d.metric1)
                    })
                    .y(d => {
                        return y1Scale(+d.metric2)
                    })

                return line(d.values)
            })
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

        // Add the dots for the tooltip
        d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        var div = d3.select(divId).append('div').attr('class', 'tooltip')
            .attr('style', 'position: absolute; opacity: 0;')

        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
        var y1tip = tooltip_class()

       y1tip.attr('class', 'd3-tip'+divId.id)
            .html((d)=> {
                return chart.x1MetricTooltip+ colonAnnotation+ d.metric1+ "<br/>"+ chart.x2MetricTooltip
                + colonAnnotation+ d.dim1_name+ "<br/>" +chart.y1MetricTooltip + colonAnnotation+ numberFormat(d.metric2)
            })

       svg.call(y1tip);*/

        svg.selectAll("dot")
            .data(data)
            .enter()
            .append("circle")
            .attr("r", 5)
            .attr("cx", function (d) {
                return x1Scale(d.metric1);
            })
            .attr("cy", function (d) {
                return y1Scale(d.metric2);
            })
            .style("fill", d => {
                return metric1ColorScale(d.dim1_name)
            })
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>"
                    + chart.x1MetricTooltip + colonAnnotation + d.metric1 + "<br/>"
                    + chart.y1MetricTooltip + colonAnnotation + numberFormat(d.metric2))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            });
        /*.on("mouseover", y1tip.show)
           .on("mouseout", y1tip.hide)
           .on('contextmenu',  contextMenu(downloadData));*/ //commented due to hardcoding

        if (gridflag == true) {
            // add the X gridlines
            svg.append("g")
                .attr("class", "grid")
                .attr("transform", "translate(0," + chart.height + ")")
                .call(make_x_gridlines(x1Scale)
                    .tickSize(-chart.height)
                    .tickFormat(""))

            // add the Y gridlines
            svg.append("g")
                .attr("class", "grid")
                .call(make_y_gridlines(y1Scale)
                    .tickSize(-chart.width)
                    .tickFormat(""))
        }
        var y1legend = svg.append('g')
            .selectAll('g')
            .data(sumstat)
            .enter()
            .append('g')
            //.attr('transform', (d, i) => 'translate(0,' + i * 20 + ')')
            .attr('transform', function (d, i) {                     // NEW
                //  var height = 0;          // NEW
                var horz = 180 * i; // NEW
                var vert = 6;       // NEW
                return 'translate(' + horz + ',' + vert + ')';        // NEW
            });

        y1legend.append('rect')
            .attr('x', 10)
            .attr('y', chart.height + chart.margin.bottom - 60)
            .attr('width', 15)
            .attr('height', 15)
            .attr('fill', d => {
                return metric1ColorScale(d.key)
            })

        y1legend.append('text')
            .data(sumstat, (d) => {
                return d.key
            })
            .attr('x', 40)
            .attr('y', chart.height + chart.margin.bottom - 60)
            .attr('dy', '0.75em')
            .text((d) => {
                return d.key.substring(0, 11)
            })
            .style('font-size', '25px')
    });
}
